import { request } from './client';

/**
 * 独立生成语音（不依赖标签ID）
 * @param {{text: string, voice?: string, format?: string, sampleRate?: number}} payload
 * @returns {Promise<{fileUrl: string, fileSize: number, format: string, voice: string, sampleRate: number}>}
 */
export const generateVoice = async (payload) => {
  return request('/voice/generate', {
    method: 'POST',
    body: payload,
  });
};

/**
 * 获取可用的发音人列表
 * @returns {Promise<Array<{code: string, name: string, description: string, gender: string, language: string, scene: string, isDefault: boolean}>>}
 */
export const getVoiceSpeakers = async () => {
  return request('/voice/speakers', {
    method: 'GET',
  });
};

export default {
  generateVoice,
  getVoiceSpeakers,
};
